// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__DDMD3","popupCloseCross":"Popup_popupCloseCross__bmkVl"};